var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06446 9.2366H3.38438C2.97796 9.23661 2.5783 9.33913 2.22332 9.53444C1.86834 9.72974 1.56983 10.0113 1.35613 10.3525C1.14244 10.6937 1.02063 11.0831 1.0023 11.4837C0.983961 11.8844 1.0697 12.2831 1.25136 12.6418L5.42439 20.8784C5.62247 21.2696 5.92709 21.5986 6.30406 21.8285C6.68104 22.0584 7.11546 22.18 7.5586 22.1798H12.348C12.5424 22.1798 12.7367 22.1563 12.9263 22.1092L17.4105 21.0032M9.06446 9.2366V3.35331C9.06446 2.72918 9.31569 2.1306 9.76289 1.68927C10.2101 1.24794 10.8166 1 11.449 1H11.5623C12.1585 1 12.6413 1.47655 12.6413 2.06487C12.6413 2.90501 12.8929 3.72631 13.3663 4.42525L17.4105 10.4133V21.0032M9.06446 9.2366H11.449M17.4105 21.0032H19.7951C20.4275 21.0032 21.0341 20.7552 21.4813 20.3139C21.9285 19.8726 22.1797 19.274 22.1797 18.6498V11.5899C22.1797 10.9658 21.9285 10.3672 21.4813 9.92587C21.0341 9.48453 20.4275 9.2366 19.7951 9.2366H16.8144",
    stroke: "#32325A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.3e1ce284d719c2b3c592bc0815faf36f.svg";
export { ForwardRef as ReactComponent };